export default "__VITE_ASSET__DANA2ncu__"